import React from 'react';
import {createSourcePackageItem} from '../../utils/api/sourcePackage';
import {useSession} from '../../firebase/UserProvider';
import {useYSourcePackage} from '../sourcePackage/hooks';

/**
 * Hook for managing folder creation logic
 */
export function useFolderCreation(onAddToSourceFolder, onClose) {
    const [error, setError] = React.useState(null);
    const {addFolder} = useYSourcePackage();
    const {user} = useSession();

    const createFolder = React.useCallback(async (name, parentFolder = null, productId = null) => {
        console.log(name, 'parentFolder:', parentFolder, 'productId:', productId);

        try {
            if (productId) {
                // Creating folder in another product - use API
                // Backend expects parentFolderId as a numeric Long (or null)
                const numericParentId = parentFolder != null && !isNaN(Number(parentFolder))
                    ? Number(parentFolder)
                    : null;
                await createSourcePackageItem(productId, {
                    type: 'FOLDER',
                    parentFolderId: numericParentId,
                    entity: {
                        name: name || 'New folder',
                        folderIndex: 0,
                    },
                    userId: user?.uid ?? null,
                });

                // For cross-product, we don't auto-add the item
                onClose?.();
                return null;
            } else {
                // Creating folder in current product — write to Yjs
                const id = addFolder({name, parentFolderId: parentFolder ?? null, userId: user?.uid});

                // Auto-select the newly created folder
                if (id && typeof id === 'string') {
                    onAddToSourceFolder?.(id);
                }

                onClose?.();
                return id;
            }
        } catch (e) {
            console.error('Failed to create folder:', e);
            setError(e?.message || String(e));
            throw e;
        }
    }, [addFolder, onAddToSourceFolder, onClose, user?.uid]);

    return {
        createFolder,
        error,
        setError,
    };
}
